const API_BASE = process.env.REACT_APP_API_URL || "";

async function get(path) {
  const r = await fetch(`${API_BASE}${path}`);
  if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
  return r.json();
}

export const API_URL = API_BASE;

export const api = {
  stats: () => get("/api/stats"),
  search: (q, limit = 10) => get(`/api/search?q=${encodeURIComponent(q)}&limit=${limit}`),
  player: (id) => get(`/api/player/${id}`),
  network: (id, limit = 50) => get(`/api/player/${id}/network?limit=${limit}`),
  team: (id, season) => get(`/api/team/${id}${season ? `?season=${encodeURIComponent(season)}` : ""}`),
  path: (fromId, toId) => get(`/api/path?from_id=${fromId}&to_id=${toId}`),
  tournament: () => get(`/api/tournament`),
};
